import React, { useState, useEffect } from 'react';
import { BsGithub, BsLinkedin } from 'react-icons/bs';
import './Navbar.scss';
import images from '../../constants/images';
import { Controls, PlayState, Tween } from 'react-gsap';


const Navbar = () => {
    const [navOpen, setNavOpen] = useState(false);
    const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');

    const handleToggleTheme = () => {
        const newTheme = theme === 'light' ? 'dark' : 'light';
        localStorage.setItem('theme', newTheme);
        setTheme(newTheme);
    };

    useEffect(() => {
        const root = document.documentElement;
        if (theme === 'light') {
            root.style.setProperty('--primary-color', '#111414');
            root.style.setProperty('--lightGray-color', '#EFEFEF');
            root.style.setProperty('--gray', '#3E4040');
        } else {
            root.style.setProperty('--primary-color', '#EFEFEF');
            root.style.setProperty('--lightGray-color', '#111414');
            root.style.setProperty('--gray', '#3E4040');
        }
    }, [theme]);


    return (
        <section id='navbar'>
            <div className="navbar">
                <Tween from={{ y: '50px', opacity: 0 }} to={{ y: '0px', opacity: 1 }} ease="Expo.easeOut" duration={2} stagger={0.09} delay={1}>
                    <div className="Logo-container">
                        <a href="/" className={theme === 'light' ? "nav_logo dark" : "nav_logo light"}>
                            Nicola Lino.
                        </a>

                    </div>
                </Tween>
                <Tween from={{ y: '50px', opacity: 0 }} to={{ y: '0px', opacity: 1 }} ease="Expo.easeOut" duration={2} stagger={0.09} delay={1}>

                    <div className={theme === 'light' ? "right__container dark" : "right__container light"}>
                        <div className="nav__theme" onClick={handleToggleTheme}>
                            <div className="nav__theme__icon">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" className={theme === 'light' ? "" : "hidden"}><path fill="none" d="M0 0h12v12H0z"></path><path fill="currentColor" d="M6.315 10.617q-.223 0-.448-.02a4.93 4.93 0 0 1-.876-9.66.394.394 0 0 1 .486.486 4.142 4.142 0 0 0 5.1 5.1.394.394 0 0 1 .486.486 4.943 4.943 0 0 1-4.748 3.608Zm-1.741-8.69a4.142 4.142 0 1 0 5.5 5.5 4.931 4.931 0 0 1-5.5-5.5Z"></path></svg>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.997 11.999" className={theme === 'light' ? "hidden" : ""}><path fill="currentColor" d="M5.599 11.601v-1a.4.4 0 0 1 .4-.4.4.4 0 0 1 .4.4v1a.4.4 0 0 1-.4.4.4.4 0 0 1-.4-.4Zm4.075-1.356-.708-.707a.4.4 0 0 1 0-.565.4.4 0 0 1 .567 0l.705.707a.4.4 0 0 1 0 .565.391.391 0 0 1-.282.117.4.4 0 0 1-.28-.12Zm-7.919 0a.4.4 0 0 1 0-.565l.707-.707a.4.4 0 0 1 .565 0 .4.4 0 0 1 0 .565l-.707.707a.39.39 0 0 1-.283.117.393.393 0 0 1-.28-.12Zm.493-4.533a3.463 3.463 0 0 1 3.457-3.46 3.463 3.463 0 0 1 3.457 3.46 3.46 3.46 0 0 1-3.457 3.456A3.46 3.46 0 0 1 2.25 5.709Zm.813 0a2.648 2.648 0 0 0 2.645 2.642 2.646 2.646 0 0 0 2.645-2.642 2.647 2.647 0 0 0-2.645-2.645 2.649 2.649 0 0 0-2.644 2.642Zm7.537.689a.4.4 0 0 1-.4-.4.4.4 0 0 1 .4-.4h1a.4.4 0 0 1 .4.4.4.4 0 0 1-.4.4Zm-10.2 0a.4.4 0 0 1-.4-.4.4.4 0 0 1 .4-.4h1a.4.4 0 0 1 .4.4.4.4 0 0 1-.4.4Zm8.568-3.367a.4.4 0 0 1 0-.568l.708-.705a.4.4 0 0 1 .564 0 .4.4 0 0 1 0 .565l-.705.708a.407.407 0 0 1-.284.114.406.406 0 0 1-.281-.117Zm-6.5 0-.707-.708a.4.4 0 0 1 0-.565.4.4 0 0 1 .565 0l.707.705a.4.4 0 0 1 0 .568.406.406 0 0 1-.282.114.4.4 0 0 1-.285-.117Zm3.137-1.632v-1a.4.4 0 0 1 .4-.4.4.4 0 0 1 .4.4v1a.4.4 0 0 1-.4.4.4.4 0 0 1-.404-.401Z"></path></svg>
                            </div>

                            <div className={theme === 'light' ? "theme__text" : "theme__text hidden"} >Dark</div>
                            <div className={theme === 'light' ? "theme__text hidden" : "theme__text"}>Light</div>
                        </div>

                        <div className="menu-toggle" onClick={() => setNavOpen(!navOpen)}>
                            <div className="hamBox">
                                <span className={navOpen ? "lineTop spin" : "lineTop"}></span>
                                <span className={navOpen ? "lineCenter spin" : "lineCenter"}></span>
                                <span className={navOpen ? "lineBottom spin" : "lineBottom"}></span>
                            </div>
                        </div>
                    </div>
                </Tween>

            </div>

            <div className="nav">
                <div className="nav-overlay" style={{
                    top: navOpen ? "0" : "-100%",
                    transitionDelay: navOpen ? "0s" : "0s",
                }}>
                    <div className="menu">
                        <ul className='nav-links'>
                            {['home', 'about', 'projects'].map((item) => (
                                <li className='nav-item' key={`link-${item}`}>
                                    <a className='rolling-text' onClick={() => setNavOpen(!navOpen)} href={`#${item}`} style={{
                                        top: navOpen ? "0" : "120px",
                                        transitionDelay: navOpen ? "0.8s" : "0s",
                                    }}>{`${item}`} </a>
                                    <div className="nav-item-wrapper"></div>
                                </li>
                            ))}
                            <li className='nav-item'>
                                <a className='rolling-text' onClick={() => setNavOpen(!navOpen)} href="mailto:nicola.abu.shaibeh@gmail.com" title="Send me an email" style={{
                                    top: navOpen ? "0" : "120px",
                                    transitionDelay: navOpen ? "0.8s" : "0s",
                                }}>contact</a>
                                <div className="nav-item-wrapper"></div>
                            </li>
                        </ul>
                    </div>
                    <div className="nav-footer">
                        <div className="location" style={{
                            bottom: navOpen ? "0" : "-20px",
                            opacity: navOpen ? "1" : "0",
                            transitionDelay: navOpen ? "1.2s" : "0s",
                        }}>
                            <span>Bethlehem, PA</span>
                        </div>
                        <div className="nav-social-media" style={{
                            bottom: navOpen ? "0" : "40px",
                            opacity: navOpen ? "1" : "0",
                            transitionDelay: navOpen ? "1.2s" : "0s",
                        }}>
                            <a href="https://www.linkedin.com/in/nicolaabushaibeh/" target="_blank">
                                <BsLinkedin className='icon' />
                            </a>
                            <a href="https://github.com/NicolaLino" target="_blank">
                                <BsGithub className='icon' />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Navbar;